<template>
  <div class="about" id="about">
    <three-dots class="dots"/>
    <div class="title">Давайте знакомиться</div>
    <div class="about-block  align-items-center">
      <div class="photo">
        <img src="@/assets/photo.png" class="photo-mainphoto" alt="">
      </div>
      <div class="about-block-text">
        <div class="about-name">Меня зовут <span>Светлана Рамбелли</span></div>
        <p class="about-text">Я - практикующий психолог. Веду частную практику в <strong>онлайн формате</strong>.</p>
        <p class="about-text"><strong>Моё образование:</strong></p>
        <div class="about-list first"><dot/> <p>Московский институт психоанализа. Профиль: <strong>психологическое консультирование и диагностика личности</strong>.</p></div>
        <div class="about-list"><dot/> <p>Волгоградская гуманитарная академия. Квалификация: <strong>семейный психолог</strong>.</p></div>
        <div class="about-list"><dot/> <p>Высшая школа <strong>"Среда обучения": курс "Учимся принимать себя"</strong>.</p></div>
        <div class="about-list"><dot/><p> Италия, Болонья,<strong> "Центр благополучия и здоровья"</strong>.</p></div>
        <div class="block-editor"></div>
        <router-link to="/about" class="button">Подробнее <under-arrow/></router-link>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
  .about {
    display: block;
    padding: 64px;
    position: relative;
    &-block {
      display: flex;
      justify-content: center;
      max-width: 1050px;
      margin-left: auto;
      margin-right: auto;
      &-text {
        font-family: 'Raleway', sans-serif;
        position: relative;
        .block-editor {
          display: none;
          position: absolute;
          width: 100%;
          height: 65%;
          background-image: -webkit-gradient(linear,left top,left bottom,from(hsla(0,0%,100%,0)),to(var(--white)));
          background-image: linear-gradient(180deg,hsla(0,0%,100%,0),var(--white));
        }
        .about-name {
          font-size: 24px;
          font-weight: 600;
          color: #1f1f1f;
          margin-top: 0;
          margin-bottom: 24px;
          span {
            color: #55cce7;
          }
        }
        .about-text {
          font-size: 17px;
          color: #1f1f1f;
          font-weight: 300;
          margin-top: 0;
          margin-bottom: 24px;
          strong {
            font-weight: 500 !important;
          }
        }
        .about-list {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          margin-bottom: 24px;
          margin-top: 0;
          font-size: 17px;
          color: #1f1f1f;
          width: 100%;
          p {
            font-weight: 300;
            margin-bottom: 0;
            strong {
              font-weight: 500 !important;
            }
          }
          svg {
            margin-right: 12px;
            width: 3%;
            height: 5px;
          }
        }
        .button {
          width: 181px;
          height: 48px;
          border-radius: 9px;
          background-color: #55cce7;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 17px;
          font-weight: 600;
          color: #ffffff;
          margin-top: 58px;
          svg {
            margin-left: 20px;
            transform: rotate(-90deg);
          }
        }
      }
    }
    .photo {
      display: block;
      max-width: 420px;
      width: 100%;
      margin-right: 160px;
      position: relative;

      &-bgdots {
        max-width: 165px;
        width: 100%;
        position: absolute;
        top: 0;
        right: -50px;
      }
      &-bgborder {
        border: solid 0.5px #7e7e7e;
        width: 86%;
        height: 90%;
        display: block;
        position: absolute;
        border-radius: 9px;
        bottom: -20px;
        left: 20px;
      }
      &-bgcolor {
        position: absolute;
        display: block;
        z-index: 1;
        width: 86%;
        height: 90%;
        border-radius: 9px;
        background-color: #ecf6f8;
        bottom: 5px;
        left: 54px;
      }
      &-mainphoto {
        width: 100%;
        position: relative;
        z-index: 4;
      }
    }
  }


  @media screen and (max-width: 1050px) {
    .about {
      &-block {
        .photo {
          margin-right: 30px;
          margin-bottom: 40px;
        }
      }
    }
  }

  @media screen and (max-width: 885px) {
    .about {
      &-block {
        display: block;
        .photo {
          margin-left: auto;
          margin-right: auto;
          max-width: 350px;
          margin-bottom: 40px;
        }
        &-text {
          .about-list {
            display: none;
          }
          .first {
            display: flex;
          }
          .block-editor {
            display: block;
            bottom: 60px;
          }
          .about-name {
            text-align: center;
          }
          .button {
            margin-left: auto;
            margin-top: 24px;
            margin-right: auto;
          }
        }
      }
    }
  }

  @media screen and (max-width: 768px) {
    .about {
      &-block {
        display: block;
        .photo {
          margin-left: auto;
          margin-right: auto;
          margin-bottom: 40px;
        }
      }
    }
  }
  @media screen and (max-width: 550px){

    .about {
      padding: 48px 24px;
      .about-block-text .about-list svg {
        width: 5%;
      }
      .title {
        margin-bottom: 32px;
      }
    }
  }

</style>
<script>
  import UnderArrow from '@/components/icons/UnderArrow';
  import ThreeDots from '@/components/icons/ThreeDots';
  import Dot from '@/components/icons/Dot';
  export default {
    name: 'About',
    components: { UnderArrow, ThreeDots, Dot },
    methods: {
      handleScroll(event) {
        var element = document.querySelector("#about");
        var top = element.offsetTop;
        setTimeout(() => {
          window.scrollY < top ? () => {this.$emit('hideFixednav');} : () => {this.$emit('showFixednav')}
        }, 100)
      }
    },
    created() {
      window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
      window.removeEventListener('scroll', this.handleScroll);
    },
    mounted() {
      window.addEventListener('scroll', this.handleScroll)
      this.handleScroll;
    }
  }
</script>
